(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientTemplate', PatientTemplate);

    PatientTemplate.$inject = ['$resource'];

    function PatientTemplate ($resource) {
        var resourceUrl =  'api/patient-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
